<script lang="ts">
  import globalStore from '@/stores/global.svelte'

  let {
    children,
    class: classNames = '',
  } = $props()

  let active = $state(false)
  let currentUser = $derived(globalStore.currentUser)
</script>

{#if currentUser.superadmin}
  <div
    class="SuperadminAccordion sa-accordion sa-border {classNames}"
    class:active={active}
    onclick={() => active = true}
    onkeyup={(evt) => evt.key === 'Enter' ? active = true : null}
    tabindex="0"
    role="button"
  >
    <button
      class="btn-close icon icon--close-orange"
      onclick={() => active = false}
      aria-label="Close"
    ></button>
    {@render children?.()}
  </div>
{/if}
